import { type IntegrationSettingKey } from '@webapp/core/services/IntegrationsAPIClient/IntegrationsAPIClient.service'

export const BUSINESS_CENTRAL_COMPANY_ID_SETTING_KEY =
  'business_central_company_id'
export const BUSINESS_CENTRAL_COMPANY_REMOTE_ID_SETTING_KEY =
  'business_central_company_remote_id'
export const BUSINESS_CENTRAL_COMPANY_SETTING_KEYS: IntegrationSettingKey[] = [
  BUSINESS_CENTRAL_COMPANY_ID_SETTING_KEY,
  BUSINESS_CENTRAL_COMPANY_REMOTE_ID_SETTING_KEY,
]

export interface BusinessCentralCompanyConstructor {
  remoteId: string
  mergeId: string
  /** Null when Merge has neither a name nor a legal name for the company */
  name: Nullable<string>
}

/**
 * A company in the connected Business Central account. `remoteId` is the
 * company's own Business Central ID and `mergeId` is Merge's company-info ID.
 * Saving the integration's company stores both because pushes need both.
 */
export class BusinessCentralCompany {
  readonly remoteId: string
  readonly mergeId: string
  readonly name: Nullable<string>

  constructor(data: BusinessCentralCompanyConstructor) {
    this.remoteId = data.remoteId
    this.mergeId = data.mergeId
    this.name = data.name
  }
}
